/**
 * Variant selection for Inga product pages (color swatches + option selects).
 */
(function () {
  function initProductForm(section) {
    const formComponent = section.querySelector('product-form-component');
    if (!formComponent) return;

    const form = formComponent.querySelector('form[data-type="add-to-cart-form"]');
    const variantInput = formComponent.querySelector('[ref="variantId"]');
    const variantsScript = section.querySelector('[data-inga-product-variants]');
    const priceEl = section.querySelector('[data-inga-product-price]');
    const submitBtn = form?.querySelector('[type="submit"][name="add"]');

    if (!form || !variantInput || !variantsScript) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (_) {
      return;
    }

    const optionNames = Array.from(form.querySelectorAll('[data-option-name]'))
      .map((el) => el.dataset.optionName)
      .filter(Boolean)
      .filter((name, index, list) => list.indexOf(name) === index);

    function getSelectedValues() {
      return optionNames.map((name) => {
        const swatch = form.querySelector(
          `[data-variant-swatch][data-option-name="${name}"].is-selected`
        );
        if (swatch) return swatch.dataset.optionValue;

        const select = form.querySelector(`[data-variant-select][data-option-name="${name}"]`);
        return select ? select.value : '';
      });
    }

    function findVariant() {
      const selected = getSelectedValues();
      return variants.find((variant) =>
        variant.options.every((value, index) => value === selected[index])
      );
    }

    function formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
      }
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'ZAR' });
    }

    function updateVariant() {
      const variant = findVariant();
      if (!variant) return;

      variantInput.value = variant.id;

      if (priceEl && variant.price != null) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (submitBtn) {
        const available = variant.available !== false;
        submitBtn.disabled = !available;
        submitBtn.textContent = available
          ? submitBtn.dataset.addLabel || 'Add to cart'
          : 'Sold out';
      }
    }

    form.querySelectorAll('[data-variant-select]').forEach((select) => {
      select.addEventListener('change', updateVariant);
    });

    form.querySelectorAll('[data-variant-swatch]').forEach((swatch) => {
      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        const group = swatch.closest('[data-variant-swatches]');
        group?.querySelectorAll('[data-variant-swatch]').forEach((btn) => {
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('is-selected');
        swatch.setAttribute('aria-pressed', 'true');

        const hiddenSelect = form.querySelector(
          `[data-variant-select][data-option-name="${swatch.dataset.optionName}"]`
        );
        if (hiddenSelect) hiddenSelect.value = swatch.dataset.optionValue;

        updateVariant();
      });
    });

    updateVariant();
  }

  document.querySelectorAll('.inga-product').forEach((section) => {
    initProductForm(section.closest('.shopify-section') || section);
  });
})();
